import { APP_STATE, INITIALIZE_SUCCESS } from './contants';

const reducer = (state, action) => {
    switch (state.appState) {
    case APP_STATE.INITIALIZING:
        if (action.type === INITIALIZE_SUCCESS) {
            return {
                appState: APP_STATE.INITIALIZED
            };
        }
        return state;
    case APP_STATE.INITIALIZED:
    default:
        return state;
    }
};

export default reducer;
